import { useEffect } from "react";

const API_BASE = process.env.REACT_APP_API_BASE || "https://beintelli.engaggio.com/handlers";

const destinations = {
  parent: "/parent",
  learner: "/child",
  educator: "/educator",
  institution: "/institution",
};

export default function OAuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const token = params.get("token");
    const role = params.get("role");

    if (!token || !role) {
      window.location.href = "/?error=oauth_failed";
      return;
    }

    localStorage.setItem("token", token);
    localStorage.setItem("role", role);

    // Fetch profile so name/email are available immediately
    fetch(`${API_BASE}/user/profile`, {
      headers: { Authorization: `Bearer ${token}` },
    })
      .then((r) => r.json())
      .then(({ user }) => {
        if (user) {
          if (user.full_name || user.username) localStorage.setItem("name", user.full_name || user.username || "");
          if (user.username) localStorage.setItem("username", user.username || "");
          if (user.email) localStorage.setItem("email", user.email || "");
          if (user.phone) localStorage.setItem("phone", user.phone || "");
        }
      })
      .catch(() => {})
      .finally(() => {
        window.location.href = destinations[role] || "/";
      });
  }, []);

  return (
    <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "center", height: "100vh", gap: 16 }}>
      <div style={{ width: 40, height: 40, border: "3px solid #e5e7eb", borderTopColor: "#6366f1", borderRadius: "50%", animation: "spin 0.8s linear infinite" }} />
      <p style={{ color: "#6b7280", fontSize: 15 }}>Signing you in with Google...</p>
      <style>{`@keyframes spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
